export enum CREAppTypeEnum {
  LANDING = 'LANDING',
  CMS = 'CMS',
  BANNER_CATEGORY = 'BANNER_CATEGORY',
  BANNER_CLUB = 'BANNER_CLUB',
}

export type CREBannerByContextPayload = {
  type: CREAppTypeEnum.BANNER_CATEGORY | CREAppTypeEnum.BANNER_CLUB
  bannerRefIds: number[]
  language: string
}

export const CRE_DATA_VIDEO_THUMB = 'data-cre-video-thumb'
export const CRE_DATA_VIDEO_SRC = 'data-cre-video-src'
export const CRE_DATA_VIDEO_EXT = 'data-cre-video-ext'
export const CRE_ELEMENT_TYPE = 'data-cre-element'
export const CRE_DATA_VIDEO_CONTROLS = 'data-video-controls'
export const CRE_DATA_BLOCK_CONTAINER = 'data-cre-block-container'
export const CRE_DATA_BLOCK_CONTAINER_TRIGGER = 'data-cre-block-container-trigger'
export const CRE_DATA_COL_ID = 'data-cre-c'

export type CREAppByContextPayload = {
  draft?: number
  referenceId?: number
  type?: CREAppTypeEnum
  id?: number
  language?: string
}

export type CRE = {
  id: number
  organizationId: number
  name: string
  draft: boolean
  deletedAt?: Date
  createdAt?: Date
  updatedAt?: Date
  language: string
  content: string
}

export type CREAppType = {
  id: number
  cre?: CRE
  creId: number
  organizationId: number
  referenceId: number
  reference: any
  type: CREAppTypeEnum
  draft: number
  appChannels: any[] //TODO
  publishedAt?: Date | null
  createdAt?: Date
  updatedAt?: Date
  details?: CREAppDetails
}

export interface CREAppDetails {
  id: string
  creAppId: number
  title: string
  description: string
  slug: string
  createdAt?: Date
  updatedAt?: Date
}
